/**
 * @fileoverview Case Ingestion Page V2 — Simplified wizard for creating and populating legal matters.
 *
 * Goals over V1:
 * - Flatter state model (useReducer instead of deeply nested context)
 * - Clearer separation: persistence layer vs. UI vs. navigation
 * - Steps are self-contained — each step owns its own data fetching & saving
 * - Navigation is declarative — no save-before-navigate side-effects in the router
 *
 * Routes:
 * - `/matters/ingestion/v2`              — Start fresh (creates new matter)
 * - `/matters/:matterId/ingestion/v2`    — Resume existing matter
 *
 * @see src/components/case-ingestion-v2/README.md
 */
import React from 'react';

import { IngestionShell } from './components/IngestionShell';
import { IngestionProvider } from './state/IngestionProvider';

export function CaseIngestionPageV2(): React.JSX.Element {
  return (
    <IngestionProvider>
      <IngestionShell />
    </IngestionProvider>
  );
}
